//  Name: certificate
import EventBus from '@/helpers/event-bus'
import '@/components/item-certificate'

export default {
  data () {
    return {
      certificates: null
    }
  },
  mounted () {
    var vm = this
    EventBus.$emit('waitMessage')
    vm.$http.get('courses/historial/')
    .then(function (response) {
      var data = response.body
      console.log(data)
      if (data.status === 'ok') {
        EventBus.$emit('dismissMessage')
        vm.$set(vm, 'certificates', data.certificate)
      } else {
        EventBus.$emit('errorMessage', data.message)
      }
    }, function (error) {
      console.error(error)
      EventBus.$emit('errorMessage', 'Error de  comunicación con el servidor')
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/certificate/script.js